import { render } from "./category-and-groups.vue?vue&type=template&id=0371d051&scoped=true&lang=pug"
import script from "./category-and-groups.vue?vue&type=script&lang=js"
export * from "./category-and-groups.vue?vue&type=script&lang=js"

import "./category-and-groups.vue?vue&type=style&index=0&id=0371d051&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0371d051"]])

export default __exports__